import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { getIntervalByQuantity } from 'app/React/Util/intervals'
import { getPriceByInterval } from 'app/React/Util/pricegroups'
import ViabillPrice from 'app/React/ProductForm/ViabillPrice'

function Price() {
  const [strings] = useEnvValue('strings', null)
  const [intervals] = useEnvValue('intervals', null)
  const [selectedVariation] = useEnvValue('selectedVariation', null)
  const [selectedQuantity] = useEnvValue('selectedQuantity')

  const [shouldAddPlantingPrice] = useEnvValue('planting.checked', false)
  const [plantingPrice] = useEnvValue('planting.price', 0)
  const [consultingPrice] = useEnvValue('planting.consultPrice', 0)
  const [addConsulting] = useEnvValue('planting.addConsulting', false)

  if (selectedVariation === null) return;

  const interval = getIntervalByQuantity(intervals, selectedQuantity)

  if (interval === null) {
    return (<aside className="mtt-price-wrap">
      <ViabillPrice/>
    </aside>)
  }

  const price = getPriceByInterval(selectedVariation?.pricegroup?.prices ?? {}, interval.key)
  if (price === null) {
    return (<aside className="mtt-price-wrap">
      <ViabillPrice/>
    </aside>)
  }

  const plantingAndOrConsultingPrice = () => {
    if (!shouldAddPlantingPrice || plantingPrice <= 0) {
      return null
    }

    if (addConsulting) {
      return plantingPrice + consultingPrice
    }

    return plantingPrice
  }

  return (
    <aside className="mtt-price-wrap">
      <ViabillPrice price={price.price} selectedQuantity={selectedQuantity}/>

      <div id="price" className="mtt-price-wrap__content">
        <div className="mtt-price-wrap__price-wrap">
          <span className="mtt-price-wrap__price">
            <span className="woocommerce-Price-amount amount"><bdi>{price.price} {strings.priceEnding}</bdi></span>{' '}
            <span className="mtt-price-wrap__price-after">{strings.unitAmount}</span>
          </span>
          <span className="mtt-price-wrap__total">
            <span className="mtt-price-wrap__total-amount">
              {
                new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' })
                  .format(parseInt(price.price) * selectedQuantity)
                  .replace(',00', '')
              }
            </span>{' '}
            <span className="mtt-price-wrap__price-after">
              {strings.vatIncluded}
            </span>
          </span>
          {plantingAndOrConsultingPrice() !== null ? (
            <span className="mtt-price-wrap__total">
              {'+'}
              <span className="mtt-price-wrap__total-amount">
                {
                  new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' })
                    .format(plantingAndOrConsultingPrice())
                    .replace(',00', '')
                }
              </span>{' '}
              <span className="mtt-price-wrap__price-after">
                {strings.vatIncluded}
              </span>
            </span>
          ) : null}
        </div>
      </div>
    </aside>
  )
}

export default observer(Price)